import service from '@/util/service';

// project
export const getProjectList = params => service.jsonGet('/api/business/project/projectList', params);

export const getMsgCount = params => service.jsonGet('/api/business/project/projectList/mark', params);

export const getProject = params => service.jsonGet('/api/business/project/info', params);

export const getProjectView = params => service.jsonGet('/api/business/project/rootProjectInfo', params);

export const addTopProject = params => service.jsonPost('/api/business/project/addTop', params);

export const cancelTopProject = params => service.jsonPost('/api/business/project/cancelTop', params);

export const mergeProject = params => service.jsonPost('/api/business/project/merge', params);

export const deleteProject = params => service.jsonPost('/api/business/project/batchDel', params);

export const addProject = params => service.jsonPost('/api/business/project/addProject', params);

export const updateProject = params => service.jsonPost('/api/business/project/updateProject', params);

export const getProjectMsgList = params => service.jsonGet('/api/business/project/message', params);

export const getProjectTreeList = params => service.jsonGet('/api/business/project/treeList', params);

export const getSplitView = params => service.jsonGet('/api/business/project/splitInfo', params);

export const splitProject = params => service.jsonPost('/api/business/project/split', params);

export const updateSplitProject = params => service.jsonPost('/api/business/project/splitUpdate', params);

export const getAssistView = params => service.jsonGet('/api/business/project/splitAssistInfo', params);

export const splitAssistProject = params => service.jsonPost('/api/business/project/splitAssist', params);

export const updateSplitAssistProject = params => service.jsonPost('/api/business/project/splitAssistUpdate', params);

export const splitProjectInfo = params => service.jsonGet('/api/business/project/infoBySplit', params);

export const updateParentProject = params => service.jsonPost('/api/business/project/updateParentId', params);

export const upProject = params => service.jsonPost('/api/business/project/up', params);

export const downProject = params => service.jsonPost('/api/business/project/down', params);

export const evaluateSuperior = params => service.jsonPost('/api/business/project/evaluateSuperior', params);

export const validStartWork = params => service.jsonGet('/api/business/project/validStartWork', params);



// WEBPACK FOOTER //
// ./src/api/project/project.js